<template>
  <v-container>
    <v-row class="theContainer"> 
      <v-col cols="12" md="4">
        <sideSection v-if="rendered" class="mr-12" />
      </v-col>

      <v-col cols="12" md="8">
        <v-card shaped class="shapedto" elevation="3">
          <v-row justify="center">
            <v-col cols="auto">
              <!-- <v-card-title class="font-italic">
          Superficie recasement
        </v-card-title>


       
          <v-card-title>
       <v-card-text class="font-italic body-2">

           Nombre de ménages recasés (bidonvillois): 32500

       </v-card-text>


      



       <v-card-text class="font-italic body-2">

           Nombre de ménages recasés (HMR): 9250

       </v-card-text>


   

   
       </v-card-title> -->

              <v-row>
                <v-col cols="auto">
                  <v-img class="vim" width="auto" src="test.png"></v-img>
                </v-col>
              </v-row>

              <!-- <v-data-table
         :loading="loading"
         :page.sync="page"
         :items-per-page="itemsPerPage"
         loading-text="Veuillez patienter quelques instants "
       
         @page-count="pageCount = $event"


        :options.sync="options"
        :server-items-length="totalDocuments"

        :headers="headers"
        :items="dataValues"
        hide-default-footer
        


        class="elevation-0">
       
       
       
       </v-data-table> -->
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import sideSection from '@/components/navbarComponents/sideSection';

export default {
  components: {
    sideSection,
  },
  methods: {
    checkRendering() {
      this.$store.state.toRender = true;
    },
  },
  created() {
    this.checkRendering();
  },
  computed: {
    rendered() {
      return this.$store.state.toRender;
    },
  },

  data: () => ({
    headers: [
      {
        text: 'Projets',
        value: 'projets',
        width: '300px',
      },
      { text: 'Nombre', value: 'Nombre', width: '200px' },
    ],
    dataValues: [
      { projets: 'Recasement', Nombre: '11' },
      { projets: 'Santé', Nombre: '36' },
      { projets: 'Précarité', Nombre: '47' },
      { projets: 'MJS', Nombre: '4' },
      { projets: 'AGR', Nombre: '3' },
      { projets: 'Acompagnement Social', Nombre: '2' },
      { projets: 'MOD', Nombre: '20' },
      { projets: 'Equipements Publics', Nombre: '100' },
    ],
  }),
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Karla:ital@1&family=Montserrat&display=swap');

.sp-title {
  color: #1976d2;
}

p {
  font-family: 'Karla';
}

.inerventionbuttonclass {
  margin-left: 0.8rem;
}

@media only screen and (device-width: 1920px) and (device-height: 1080px) {
  .v-card {
    margin-left: 24px !important;
    width: 87%;
  }

  .vim {
    width: 100%;
    height: 100%;
  }
}

.shapedto {
  border-radius: 30px;
}


@media (min-width: 1800px)  {
  .theContainer{
  padding-bottom: 2rem;
  padding-left: 10rem;
  padding-right: 10rem;
  display: flex;
}
}
</style>
